import { Component } from '@angular/core';
import { LibOnlineSurveyIndexComponent } from '@pishgamrayan/ng-online-survey';
import { PageNames } from 'src/app/configs/page-names.enum';

@Component({
  selector: 'app-online-survey-list',
  templateUrl: './online-survey-list.component.html',
  imports: [LibOnlineSurveyIndexComponent],
})
export class OnlineSurveyListComponent {
  pageName = PageNames.onlineSurveyList;

  onCopyLink(surveyId) {
    const url = location.origin + '/online-survey/' + surveyId;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
